export const WorkFieldData = [
  {
    id: 1,
    name: "Construction",
    icon: require("../assets/images/industries/1.png"),
  },
  {
    id: 2,
    name: "Agriculture",
    icon: require("../assets/images/industries/2.png"),
  },
  {
    id: 3,
    name: "Recyclage des déchets",
    icon: require("../assets/images/industries/3.png"),
  },
  {
    id: 4,
    name: "La gestion des déchets",
    icon: require("../assets/images/industries/4.png"),
  },
  {
    id: 5,
    name: "Aménagement paysager",
    icon: require("../assets/images/industries/5.png"),
  },
  {
    id: 6,
    name: "Infrastructures routières",
    icon: require("../assets/images/industries/6.png"),
  },
  {
    id: 7,
    name: "Exploitation minière",
    icon: require("../assets/images/industries/7.png"),
  },
  {
    id: 8,
    name: "Biomasse",
    icon: require("../assets/images/industries/8.png"),
  },
  {
    id: 9,
    name: "Coton",
    icon: require("../assets/images/industries/9.png"),
  },
  {
    id: 10,
    name: "Pétrole et gaz",
    icon: require("../assets/images/industries/10.png"),
  },
  {
    id: 11,
    name: "Produits chimiques et engrais",
    icon: require("../assets/images/industries/11.png"),
  },

  {
    id: 12,
    name: "Industrie de la brique",
    icon: require("../assets/images/industries/12.png"),
  },
  {
    id: 13,
    name: "Broyeurs de pierres",
    icon: require("../assets/images/industries/13.png"),
  },
  {
    id: 14,
    name: "Divers",
    icon: require("../assets/images/industries/14.png"),
  },
];
export default WorkFieldData;
